module.exports = __webpack_public_path__ + "img/powerline-light.dd7df5de.png";